<template>
    <div class="newMessage clearfix">
      <span>最新留言：</span>
      <van-notice-bar mode="" :scrollable="true">
          {{msgs}}
      </van-notice-bar>


    </div>
</template>

<script>
    export default {
        name: 'NewMessage',
        data () {
            return {
                msgs:'自驾租车  陈先生1595****   需要一台凯美瑞瑞三天    配驾包车  林小姐1895****   我需要一台中巴三天联系我    自驾租车  余先生1346****   需要一台宝马5系新一点的两天租车   配驾包车  陈小姐1567****   我要一台考斯特接待客户两天请联系我   自驾租车  余先生1890****   我要租一辆朗逸用2天   配驾包车  张先生1394****   我要一台55座大巴婚宴接待   自驾租车  林先生1596****   有18款的汉兰达吗？联系我    配驾包车  王小姐1334****   需要一台45座金龙客车公司要团建   自驾租车  童小姐1899****   200元租金一天有什么车子可以租的？   配驾包车  彦先生1364****   我们公司20人需要上下班接送，这儿有吗？   自驾租车  玉先生1834****   轩逸租一天多少钱？   配驾包车  吴先生1376****   丰田海狮你们家有几座的？我们12人',
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}
    .newMessage{height: 60px;background: #e5e5e5}
    .newMessage span{width: 150px;font-size:24px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(238,69,71,1);float: left;line-height: 60px;text-align: center}
</style>

<style>
  .van-notice-bar{height: 60px;line-height: 60px;background: #e5e5e5}
  .van-notice-bar__wrap{height: 60px;line-height: 60px;}
  .van-notice-bar__content{font-size:24px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(238,69,71,1);}
</style>



// WEBPACK FOOTER //
// src/components/NewMessage/NewMessage.vue